var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"listing-wrap"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"complete",attrs:{"src":require("@/assets/img/zy_complete.png")}}),_c('div',{staticClass:"list"},[_vm._v("暂无车辆信息")]),_c('div',{staticClass:"login-button"},[_c('span',{staticClass:"submit",on:{"click":_vm.addListing}},[_vm._v("添加车辆查权益")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }